import axios from "axios";
import { API } from "../constants";
import { apiUrl } from "./lt-api";

axios.defaults.baseURL = API;

const defaultHeaders = {
  crossDomain: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    withCredentials: true
  },
  responseType: 'blob'
};

const getConfigWithToken = () => {
  const token = JSON.parse(localStorage.getItem('token'));
  return {
    ...defaultHeaders,
    headers: {
      ...defaultHeaders.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
    }
  };
};

export function getPriceBreakdownCsvFile(room_variant_id) {
  return axios({
    ...getConfigWithToken(),
    method: "GET",
    url: `${apiUrl}room_variants/${room_variant_id}/price_breakdown`
  });
}
